import APILibrary, { ClassExtender, GenerateResource } from './APILibrary';
import {
  ConversationAttributes,
  ConversationHasMany,
  ConversationInterface,
  ConversationResource,
  ConversationResourceClass,
} from 'util/resources/Conversation';

/**
 * Utility interfaces
 */
export interface EmployerConversationResource extends ConversationResource {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<ConversationAttributes>({
    queryName: 'employer/conversations',
    className: 'EmployerConversation',
    AttributesClass: ConversationAttributes,
    HasManyClasses: [
      {
        Klass: ConversationHasMany,
      },
    ],
  });

export class EmployerConversationResource extends ClassExtender<ConversationInterface>(
  BaseClass,
  ConversationResourceClass,
) {}

/**
 * Resource instance
 */
export const EmployerConversation = APILibrary.createResource<EmployerConversationResource>(
  EmployerConversationResource,
);
